import { useFormik } from 'formik';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Row } from 'reactstrap';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { setFromErrors } from 'src/helpers';
import { useCreateInspectionRecognitionMutation } from 'src/rtk/features/instituteInspection/institutueInspectionApi';
import * as Yup from 'yup';
import loader from '../../assets/images/loader.gif';

const CriteriaOfRecognition = (props: any) => {

    const { goToPrevious, goToNext, instituteName, departmentId, formBDeptId, teamId, instituteId, isDisabled } = props;

    const [createInspectionRecognition, { isSuccess, isError, error, isLoading }] = useCreateInspectionRecognitionMutation();

    const err: CustomError = error as CustomError;

    const initialValues = {
        team_creation_id: teamId,
        institute_id: instituteId,
        form_b_department_id: formBDeptId,
        department_id: departmentId,
        marking_as_per_teaching_staff: '',
        marking_as_per_bed_occupancy: '',
        marking_as_per_opd_attendance: '',
        marking_as_per_extended_related_facility: '',
    }

    const {
        handleSubmit,
        getFieldProps,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        resetForm,
        setFieldValue,
        setErrors,
    } = useFormik({
        initialValues,

        validationSchema: Yup.object({

        }),

        onSubmit: (values: any) => {
            const data = {
                ...values,
                marking_as_per_teaching_staff: Number(values.marking_as_per_teaching_staff),
                marking_as_per_bed_occupancy: Number(values.marking_as_per_bed_occupancy),
                marking_as_per_opd_attendance: Number(values.marking_as_per_opd_attendance),
                marking_as_per_extended_related_facility: Number(values.marking_as_per_extended_related_facility),
            };
            createInspectionRecognition(data);
        },
    });


    useEffect(() => {
        if (isSuccess) {
            toast.success('Department information saved successfully');
            goToNext();
        }
        if (isError) {
            toast.error(err?.message || 'Something went wrong');
            setFromErrors(err.data, setErrors);
        }
    }, [isSuccess, isError]);

    return (
        <div className='page-content'>
            {isLoading ? (
                <div className="overlay">
                    <img src={loader} alt="Loading" height={100} width={300} />
                </div>
            ) : null}
            <Container fluid>
                <BetterBreadcrumb
                    title="Criteria of Recognition Form"
                />
                <Form
                    className="custom-form"
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                    onReset={(e) => {
                        e.preventDefault();
                        resetForm();
                    }}
                >
                    <Card className='px-4'>
                        <CardBody>
                            <Row>
                                <Col md={12} className='text-center'>
                                    <h5>Criteria for Recognition of Training Duration</h5>
                                    <h6>(Categorization of Faculty as per Different Parameter)</h6>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12} className='text-center mt-3'>
                                    <h6>(Facilities where Trainee has access in managing new patients of all category under supervision)</h6>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <h5>As per teaching Staff</h5>
                                <Col md={12} className='ps-4'>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_teaching_staff"
                                            id="teachingStaff1"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_teaching_staff', '7');
                                            }}
                                            checked={values.marking_as_per_teaching_staff === '7'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="teachingStaff1"
                                        >
                                            Professor + Associate Professor + Assistant Professor <span className='text-primary fw-bold'>A(7)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_teaching_staff"
                                            id="teachingStaff2"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_teaching_staff', '5');
                                            }}
                                            checked={values.marking_as_per_teaching_staff === '5'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="teachingStaff2"
                                        >
                                            Professor/Associate Professor + Assistant Professor <span className='text-primary fw-bold'>B(5)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_teaching_staff"
                                            id="teachingStaff3"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_teaching_staff', '3');
                                            }}
                                            checked={values.marking_as_per_teaching_staff === '3'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="teachingStaff3"
                                        >
                                            Professor/Associate Professor <span className='text-primary fw-bold'>C(3)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_teaching_staff"
                                            id="teachingStaff4"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_teaching_staff', '1');
                                            }}
                                            checked={values.marking_as_per_teaching_staff === '1'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="teachingStaff4"
                                        >
                                            Assistant Professor with 5 years teaching experience in under or post graduate level <span className='text-primary fw-bold'>D(1)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_teaching_staff"
                                            id="teachingStaff5"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_teaching_staff', '0');
                                            }}
                                            checked={values.marking_as_per_teaching_staff === '0'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="teachingStaff5"
                                        >
                                            Part time teaching staff <span className='text-primary fw-bold'>E(0)</span>
                                        </label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <h5>Category and points to be achieved as per bed occupancy</h5>
                                <Col md={12} className='ps-4'>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_bed_occupancy"
                                            id="categoryBedOccupancy1"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_bed_occupancy', '7');
                                            }}
                                            checked={values.marking_as_per_bed_occupancy === '7'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="categoryBedOccupancy1"
                                        >
                                            75% and above <span className='text-primary fw-bold'>A(7)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_bed_occupancy"
                                            id="categoryBedOccupancy2"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_bed_occupancy', '5');
                                            }}
                                            checked={values.marking_as_per_bed_occupancy === '5'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="categoryBedOccupancy2"
                                        >
                                            65 - 74.9% <span className='text-primary fw-bold'>B(5)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_bed_occupancy"
                                            id="categoryBedOccupancy3"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_bed_occupancy', '3');
                                            }}
                                            checked={values.marking_as_per_bed_occupancy === '3'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="categoryBedOccupancy3"
                                        >
                                            55 - 64.9% <span className='text-primary fw-bold'>C(3)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_bed_occupancy"
                                            id="categoryBedOccupancy4"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_bed_occupancy', '1');
                                            }}
                                            checked={values.marking_as_per_bed_occupancy === '1'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="categoryBedOccupancy4"
                                        >
                                            35 - 54.9% <span className='text-primary fw-bold'>D(1)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_bed_occupancy"
                                            id="categoryBedOccupancy5"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_bed_occupancy', '0');
                                            }}
                                            checked={values.marking_as_per_bed_occupancy === '0'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="categoryBedOccupancy5"
                                        >
                                            &lt;35% <span className='text-primary fw-bold'>E(0)</span>
                                        </label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <h5>Category and points to be achieved as per OPD attendance where trainees are required to attend</h5>
                                <Col md={12} className='ps-4'>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_opd_attendance"
                                            id="opdAttendance1"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_opd_attendance', '7');
                                            }}
                                            checked={values.marking_as_per_opd_attendance === '7'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="opdAttendance1"
                                        >
                                            &gt; 75 patient per day <span className='text-primary fw-bold'>A(7)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_opd_attendance"
                                            id="opdAttendance2"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_opd_attendance', '5');
                                            }}
                                            checked={values.marking_as_per_opd_attendance === '5'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="opdAttendance2"
                                        >
                                            55 - 75 patients per day <span className='text-primary fw-bold'>B(5)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_opd_attendance"
                                            id="opdAttendance3"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_opd_attendance', '3');
                                            }}
                                            checked={values.marking_as_per_opd_attendance === '3'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="opdAttendance3"
                                        >
                                            45 - 54 patients per day <span className='text-primary fw-bold'>C(3)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_opd_attendance"
                                            id="opdAttendance4"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_opd_attendance', '1');
                                            }}
                                            checked={values.marking_as_per_opd_attendance === '1'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="opdAttendance4"
                                        >
                                            30 - 44 patients per day <span className='text-primary fw-bold'>D(1)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_opd_attendance"
                                            id="opdAttendance5"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_opd_attendance', '0');
                                            }}
                                            checked={values.marking_as_per_opd_attendance === '0'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="opdAttendance5"
                                        >
                                            &lt;30 patients per day <span className='text-primary fw-bold'>E(0)</span>
                                        </label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <h5>Category and points to be achieved as per Extended related facility</h5>
                                <Col md={12} className='ps-4'>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_extended_related_facility"
                                            id="facilities1"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_extended_related_facility', '7');
                                            }}
                                            checked={values.marking_as_per_extended_related_facility === '7'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="facilities1"
                                        >
                                            Unit with emergency addmission with ICU and subspeciality services <span className='text-primary fw-bold'>A(7)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_extended_related_facility"
                                            id="facilities2"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_extended_related_facility', '5');
                                            }}
                                            checked={values.marking_as_per_extended_related_facility === '5'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="facilities2"
                                        >
                                            Unit with ICU and subspeciality services but no emergency addmission <span className='text-primary fw-bold'>B(5)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_extended_related_facility"
                                            id="facilities3"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_extended_related_facility', '3');
                                            }}
                                            checked={values.marking_as_per_extended_related_facility === '3'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="facilities3"
                                        >
                                            Unit with emergency addmission with ICU but no subspeciality services <span className='text-primary fw-bold'>C(3)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_extended_related_facility"
                                            id="facilities4"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_extended_related_facility', '1');
                                            }}
                                            checked={values.marking_as_per_extended_related_facility === '1'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="facilities4"
                                        >
                                            Unit with emergency addmission but no ICU and subspeciality services <span className='text-primary fw-bold'>D(1)</span>
                                        </label>
                                    </FormGroup>
                                    <FormGroup check className='mb-2'>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="marking_as_per_extended_related_facility"
                                            id="facilities5"
                                            onChange={(e) => {
                                                setFieldValue('marking_as_per_extended_related_facility', '0');
                                            }}
                                            checked={values.marking_as_per_extended_related_facility === '0'}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="facilities5"
                                        >
                                            Unit without emergency addmission and no ICU and subspeciality services <span className='text-primary fw-bold'>E(0)</span>
                                        </label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <h5 className='mt-4'>Category and points to be achieved as per Numerical Process</h5>
                            <ul>
                                <li>Any facility scoring 22 or above will have full recognition</li>
                                <li>Any facility scoring 17 to 21 will have recognition of 3 years</li>
                                <li>Any facility scoring 13 to 17 will have recognition of 2 years</li>
                                <li>Any facility scoring 9 to 13 will have recognition of 1 year</li>
                            </ul>

                            <FormGroup row className='mt-5'>
                                <Col>
                                    <div className='d-flex justify-content-center'>
                                        <Button color="secondary" className='me-3' onClick={() => {
                                        }}>
                                            {'Reset'}
                                        </Button>
                                        <Button color="success" onClick={() => {
                                            handleSubmit();
                                        }}>
                                            {'Save & Next'}
                                        </Button>
                                    </div>
                                </Col>
                            </FormGroup>
                        </CardBody>
                    </Card>
                </Form>
            </Container>
        </div >
    );
};

export default CriteriaOfRecognition;
